import { JSX } from "react"
import { create } from "zustand"

export type SideBarHeadOption = {
  id: number | string
  title: string
  subtitle: string
  icon?: JSX.Element | undefined
}

export type SideBarHeadState = {
  data: SideBarHeadOption | null
  setState: (data: SideBarHeadOption | null) => void
}

export const useSideBarHead = create<SideBarHeadState>((set) => ({
  data: null,
  setState: (data) => {
    set({ data })
  },
}))
